var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.75C5.67405 0.75 5.84097 0.819141 5.96404 0.942211C6.08711 1.06528 6.15625 1.2322 6.15625 1.40625V5.34375H10.0938C10.2678 5.34375 10.4347 5.41289 10.5578 5.53596C10.6809 5.65903 10.75 5.82595 10.75 6C10.75 6.17405 10.6809 6.34097 10.5578 6.46404C10.4347 6.58711 10.2678 6.65625 10.0938 6.65625H6.15625V10.5938C6.15625 10.7678 6.08711 10.9347 5.96404 11.0578C5.84097 11.1809 5.67405 11.25 5.5 11.25C5.32595 11.25 5.15903 11.1809 5.03596 11.0578C4.91289 10.9347 4.84375 10.7678 4.84375 10.5938V6.65625H0.90625C0.732202 6.65625 0.565282 6.58711 0.442211 6.46404C0.319141 6.34097 0.25 6.17405 0.25 6C0.25 5.82595 0.319141 5.65903 0.442211 5.53596C0.565282 5.41289 0.732202 5.34375 0.90625 5.34375H4.84375V1.40625C4.84375 1.2322 4.91289 1.06528 5.03596 0.942211C5.15903 0.819141 5.32595 0.75 5.5 0.75Z",
    fill: "#0FAA8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.46b95e04c610ef82fa4d046a07299395.svg";
export { ForwardRef as ReactComponent };